export default {
  title: 'Your confirmation is on its way!',
  subtitle: 'You should receive a text message shortly.',
}
